/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getPaymentHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_PAYMENT_HISTORY,
    `/api/v1/rpt/administrator/machineries/applications/${id}/transactions/lineage`,
    payload,
    callback
  );
